import type { CustomRoleTaxonomySelection } from '@revelio/data-access';

/**
 * Removes the version field from a CustomRoleTaxonomySelection object
 * This ensures that version is not sent in API queries where it's not needed
 */
export const stripVersionFromTaxonomyId = (
  taxonomySelection: CustomRoleTaxonomySelection
): Omit<CustomRoleTaxonomySelection, 'version'> => {
  const { version: _version, ...taxonomyIdWithoutVersion } = taxonomySelection;
  return taxonomyIdWithoutVersion;
};
